import { ComponentCardHandler } from "../../utils/componentHandler";
import { ComponentHandler } from "./handler";
import { userAuth } from "../auth";

export const initComponentsPage = () => {
  // Initialize component handler for copy functionality
  new ComponentHandler();

  const isLoggedIn = userAuth.getRole() === "USER";

  if (!isLoggedIn) {
    console.log("User is not logged in, redirecting to login page");
    return;
  }

  new ComponentCardHandler();
};
